import { render, staticRenderFns } from "./ReplaceRecord.vue?vue&type=template&id=2e252228&"
import script from "./ReplaceRecord.vue?vue&type=script&lang=js&"
export * from "./ReplaceRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports